import { getGridSumTableColumnsForInvestments } from '../../Investment';
import { AmountSumTableProps, GridSumTable } from '../../UI';
import { useQtInvestmentsSumTable, UseQtInvestmentsSumTableArgs } from '../hooks';
import { Investment, RecurringFrequency } from '../../generated/graphql';
import { amountToRecurring } from '../../util';

interface QtEducationInvestmentsSumTableProps
  extends UseQtInvestmentsSumTableArgs,
    Pick<AmountSumTableProps, 'className' | 'hideOnEmpty'> {
  onClickItem?: (investment: Investment) => void;
}

export function QtEducationInvestmentsSumTable({
  className,
  hideOnEmpty,
  onClickItem,
  ...useQtEducationInvestmentsSumTableArgs
}: QtEducationInvestmentsSumTableProps) {
  const { afterUpdate, isLoading, qtDetails, tUI, tInvestment } = useQtInvestmentsSumTable(
    useQtEducationInvestmentsSumTableArgs
  );

  return (
    <GridSumTable
      title={tUI('qt-education-investments-table-title')}
      sumTitle={tUI('qt-education-investments-table-sum-title')}
      className={className}
      isLoading={isLoading}
      hideOnEmpty={hideOnEmpty ?? true}
      sum={qtDetails?.totalEducation}
      sumAppendix={amountToRecurring(qtDetails?.totalEducationSavings.monthly, RecurringFrequency.Monthly)}
      rows={qtDetails?.educationAccounts || []}
      columns={getGridSumTableColumnsForInvestments({
        tInvestment,
        tUI,
        onClickItem,
        afterUpdate,
      })}
    />
  );
}
